import { render, staticRenderFns } from "./STLLOCAL-game.vue?vue&type=template&id=f62def58"
import script from "./STLLOCAL-game.vue?vue&type=script&lang=js"
export * from "./STLLOCAL-game.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports